import orderConfig from 'emun.order/order.config';
import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import "emun.salesrep/territory-manager/territory/picker/territory-picker-table.htm";
//import customerConfig from "emun.customer/customer.config";
import TerritoryParser from "emun.salesrep/territory-manager/territory/parser/territory-parser";
//import ApplyTagsPrompt from "emun.customer/picker/apply-retailer-tags-prompt";

//export const filters = customerConfig.filters;

export const views = {
	list: "table",
	//  cards: "th-large"
};

export default class TerritoryPickerController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.selected = {};
		Object.assign($ctrl, options);
		$ctrl.setTerritoryIds();
		$ctrl.query = new AutoQuery($ctrl.getAutoQueryOptions());
		$ctrl.bus = $ctrl.query.bus;
		//$ctrl.viewSelectionsChanged(); //load()
	}

	templateUrl = () => `territory-picker-${this.query.view}.htm`;

	selectAll() {
		const $ctrl = this;
		$ctrl.query.results.forEach(p => ($ctrl.selected[p.id] = true));
		this.setTerritoryIds();
	}
	clearAll() {
		this.selected = {};
		this.setTerritoryIds();
	}
	canClear() {
		return Object.keys(this.selected).length;
	}

	isSelected(territory) {
		return !!this.selected[territory.id];
	}

	setTerritoryIds() {
		this.territoryIds = Object.keys(this.selected || {});
	}

	selectionsLabel() {
		const { territoryIds: keys = [] } = this;
		if (keys.length > 4)
			return `Selected: ${keys.slice(0, 4).join(", ")} and ${keys.length -
				4} more...`;
		if (keys.length > 0) return `Selected: ${keys.slice(0, 4).join(", ")}`;
		return "No selections";
	}

	hasSelections = () => Object.keys(this.selected).length > 0;

	viewSelectionsChanged() {
		const $ctrl = this;
		const idIn = $ctrl.viewSelections
			? Object.keys($ctrl.selected || {}).join(",")
			: null;
		$ctrl.query.clearRefinements(false);
		$ctrl.query.filter("IdIn", idIn);
	}

	toggle(territory) {
		const $ctrl = this;
		console.log("toggle", territory.id, $ctrl.selected, territory);

		if ($ctrl.single) {
			$ctrl.$close(territory);
		} else if (territory.id in $ctrl.selected) {
			delete $ctrl.selected[territory.id];
			$ctrl.onTerritoryUnSelected &&
				$ctrl.onTerritoryUnSelected({ $territory: territory, ...$ctrl });
		} else {
			$ctrl.selected[territory.id] = true;
			$ctrl.onTerritorySelected &&
				$ctrl.onTerritorySelected({ $territory: territory, ...$ctrl });
		}
		this.setTerritoryIds();
	}
	select(territory) {
		const $ctrl = this;
		$ctrl.$close([territory]);
	}

	$onDestroy() {
		this.query.dispose();
	}

	parseTerritories() {
		const $ctrl = this;
		TerritoryParser({}).then(territoryIds => {
			$ctrl.selected = {};
			territoryIds.forEach(territoryId => {
				$ctrl.toggle({ id: territoryId });
			});
			$ctrl.viewSelections = true;
			$ctrl.viewSelectionsChanged();
		});
	}

	getAutoQueryOptions() {
		const $ctrl = this;
		return {
			url: "QueryTerritories.json",
			pageSize: $ctrl.$pageConfig.is("gt-sm") ? 12 : 6,
			views,
			criteria: $ctrl.criteria,
			view: "table",
//			filters,
			sortOptions: {
				'Name': 'Name: A to Z',
				'-Name': 'Name: Z to A',
			},
			hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
			orderBy: "Name,Id",
			autoLoad: true,
			append: false
		};
	}
}


